import { HttpLink } from '@apollo/client';
import { PANTHER_CONFIG } from 'Source/constants';

/**
 * An HTTP link that chooses a GraphQL API based on a condition
 */
const httpLink = new HttpLink({ uri: PANTHER_CONFIG.WEB_APPLICATION_GRAPHQL_API_ENDPOINT });

export default httpLink;
